import { $$ } from '../helpers/shortcuts';

function initializeSearchSidebar() {
  $$('.search-sidebar').forEach(($sidebar) => {
    const $button = $sidebar.querySelector('.search-sidebar-buttonwrapper > *');
    const $accordions = $sidebar.querySelector('.search-sidebar-accordions');
    const expandedText = $button.getAttribute('data-text-expanded');
    const collapsedText = $button.getAttribute('data-text-collapsed');

    let accordionsVisible = false;

    $button.addEventListener('click', () => {
      if (accordionsVisible) {
        $accordions.classList.add('hide-large-down');
        $button.textContent = collapsedText;
      } else {
        $accordions.classList.remove('hide-large-down');
        $button.textContent = expandedText;
      }

      accordionsVisible = !accordionsVisible;
    });
  });
}

function initializeSearch() {
  initializeSearchSidebar();
}

export { initializeSearch };
